<template>
  <div class="ContinueButton" v-on="isMobile ? { click: () => handleClick() } : {}">
    <div class="lottieContainer" ref="lottieContainer">
      <LottieWrapper :options="getOptions" :size="size" ref="Lottie_TiggerIcon" />
    </div>
    <p ref="copy"><SplittingText :text="copy" ref="SplittingText" /></p>
  </div>
</template>

<script>

import LottieWrapper from '@/components/LottieWrapper'
import SplittingText from '@/components/SplittingText'

import { SVGS } from '@/assets/svgs/locale_map'

import { continueButtonAudio } from '@/audio'

import { TimelineLite, Expo, TweenLite } from 'gsap'

export default {
  name: 'ContinueButton',
  props: {
    onClick: Function,
    copy: String,
    state: String,
  },
  components: {
    LottieWrapper,
    SplittingText
  },
  data() {
    return {
      size: {
        width: 142.5,
        height: 142.5
      },
    }
  },
  mounted() {
    this.initIdleStates()
    this.createAnimationTimeline()

    if ( this.isMobile ) {

        //

    } else {

      document.body.onkeydown = ( e ) => {
        if ( this.isTransitionVisible ) return

        e.preventDefault()
        if ( e.keyCode == 32 ) this.handleClick()

      }

    }
  },
  beforeDestroy() {
    document.body.onkeydown = null
  },
  computed: {
    isTransitionVisible() { return this.$store.state.ui.isTransitionVisible },
    getOptions() {
      this.svgs = SVGS[ this.$store.state.lang.LOCALE ]

      return {
        animationData: this.isMobile ? this.svgs.Phone.default : this.svgs.SpacebarButton[this.state].default,
        autoplay: true,
        loop: true
      }
    },
    isMobile() { return this.$store.state.isMobile }
  },
  methods: {
    initIdleStates() {
      TweenLite.to( this.$refs.lottieContainer, 0, { opacity: '0', y: '20%' } )
    },
    createAnimationTimeline() {
      const { lottieContainer, SplittingText } = this.$refs

      this.animateElementsIn = new TimelineLite( { paused: true } )

      this.animateElementsIn
        .to( lottieContainer, 1.2, { opacity: '1', y: '0%', ease: Expo.easeOut }, 0.3 )
        .add( () => { SplittingText.animateTextIn() }, 0.3 )

      this.animateElementsOut = new TimelineLite( { paused: true } )

      this.animateElementsOut
        .to( lottieContainer, 1.2, { opacity: '0', ease: Expo.easeOut }, 0 )
        .add( () => { SplittingText.hideText() }, 0 )
    },
    handleClick() {
      this.onClick()
      continueButtonAudio.play()
    },
    updateText() {
      // Changes 'begin' to 'continue'
      this.$refs.SplittingText.updateWord()
    }
  }
}
</script>

<style scoped lang="scss">

  @import '@/styles/core.scss';

  .ContinueButton {

    .LottieWrapper {

      width: 100%;
      max-width: rem( 600 );
      margin: rem( -240 ) auto;

      @include breakpoint( tablet ) {

        max-width: rem( 500 );
        margin: rem( -140 ) auto;

      }

      @include breakpoint( mobile-all ) {

        max-width: rem( 100 );
        margin: 0 auto rem( 10 );

      }

    }

    p {

      width: 50%;

      margin: rem( -10 ) auto;

      @include lowecaseText();

      display: none;

      @include breakpoint( mobile-all ) {

        display: block;

      }

    }

  }

</style>
